import Disclaimer from "@/dev/ui/disclaimer";
import BasicLayout from "@/layouts/basic-layout";
import SEO from "@/components/SEO";


const PolicyPage = () => {


    return(
        <BasicLayout size="xl">
            <SEO
                title="מדיניות פרטיות ותנאי שימוש"
                description="מדיניות הפרטיות ותנאי השימוש של Zoooz – מאגר מידע פילנתרופי למגזר העסקי."
                path="/zoooz-policy"
            />
            <Disclaimer/>
        </BasicLayout>
    )

}
export default PolicyPage;